import { render, staticRenderFns } from "./ComingSoon.vue?vue&type=template&id=19a65ff9&scoped=true&"
var script = {}
import style0 from "./ComingSoon.vue?vue&type=style&index=0&id=19a65ff9&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19a65ff9",
  null
  
)

export default component.exports